// src/marketing/editorial/MilestoneTimeline.tsx
import { JSX } from 'react'

type Milestone = {
  label: string
  date: string | null
  current: boolean
}

type Props = {
  milestones: Milestone[]
}

export function MilestoneTimeline({ milestones }: Props): JSX.Element {
  return (
    <div className="xtimeline">
      {milestones.map((m, i) => (
        <div key={i} className={m.current ? 'xtl xtl-hot' : 'xtl'}>
          <span className="d">{m.date ?? '—'}</span>
          <span className="l">{m.label}</span>
        </div>
      ))}
    </div>
  )
}
